import { NhealthAction } from "./action.api";

export {
    getContact,
    setContact,
    setConsent,
    getAllConsent
}

const getContact = (formData, headers) => {
    return new Promise(async (resolve) => {
        NhealthAction.econsentGetContact(formData, headers)
        .then(res => {
            resolve(res);
        })
    })
}
const setContact = (formData, headers) => {
    return new Promise(async (resolve) => {
        NhealthAction.econsentSetContact(formData, headers)
        .then(res => {
            resolve(res);
        })
    })
}
const setConsent = (formData, headers) => {
    return new Promise(async (resolve) => {
        NhealthAction.econsentSetConsent(formData, headers)
        .then(res => {
            resolve(res);
        })
    })
}
const getAllConsent = (formData, headers) => {
    return new Promise(async (resolve) => {
        NhealthAction.econsentGetAllConsent(formData, headers)
        .then(res => {
            resolve(res);
        })
    })
}